<app-header></app-header>

<!-- Buttons for Mappings, Packages, and Tests -->
<div class="button-container container mt-4">
  <button class="btn me-2"
    [ngClass]="{'btn-primary': activeSection === 'tests', 'btn-outline-primary': activeSection !== 'tests'}"
    (click)="showSection('tests')">
    Tests
  </button>

  <button class="btn me-2"
    [ngClass]="{'btn-primary': activeSection === 'packages', 'btn-outline-primary': activeSection !== 'packages'}"
    (click)="showSection('packages')">
    Packages
  </button>

  <button class="btn"
    [ngClass]="{'btn-primary': activeSection === 'mappings', 'btn-outline-primary': activeSection !== 'mappings'}"
    (click)="showSection('mappings')">
    Mappings
  </button>

</div>

<!-- Mappings Section -->
<div class="dashboard-container container mt-4" *ngIf="activeSection === 'mappings'"
  style="background: #c6c3f6; border-radius: 8px; padding: 20px; min-height: 500px;">
  <div class="mb-5">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Mappings</h2>
      <button class="btn btn-primary" (click)="openCreateMappingModal(createMappingModal)">
        Create Mapping
      </button>
    </div>
    <div class="table-responsive rounded">
      <table class="table table-bordered table-striped table-hover rounded">
        <thead class="thead-dark">
          <tr>
            <th>Company</th>
            <th>Packages</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mapping of mappings">
            <td>{{ mapping.organisationName }}</td>
            <td>
              <span *ngFor="let package of mapping.testPackages" class="badge bg-secondary me-1">
                {{ package.packageName }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Packages Section -->
<div class="dashboard-container container mt-4" *ngIf="activeSection === 'packages'"
  style="background: #c6c3f6; border-radius: 8px; padding: 20px; min-height: 500px;">
  <div class="mb-5">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Packages</h2>
      <button class="btn btn-primary" (click)="openCreatePackageModal(createPackageModal)">
        Create Package
      </button>
    </div>
    <div class="table-responsive rounded">
      <table class="table table-bordered table-striped table-hover rounded">
        <thead class="thead-dark">
          <tr>
            <th>Package Name</th>
            <th>Tests</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let package of packages">
            <td>{{ package.packageName }}</td>
            <td>
              <span *ngFor="let test of package.tests" class="badge bg-secondary me-1">
                {{ test.testName }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Tests Section -->
<div class="dashboard-container container mt-4" *ngIf="activeSection === 'tests'"
  style="background: #c6c3f6; border-radius: 8px; padding: 20px; min-height: 500px;">
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Tests</h2>
      <button class="btn btn-primary" (click)="openCreateTestModal(createTestModal)">
        Create Test
      </button>
    </div>
    <div class="table-responsive rounded">
      <table class="table table-bordered table-striped table-hover rounded">
        <thead class="thead-dark">
          <tr>
            <th>Test Name</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let test of tests">
            <td>{{ test.testName }}</td>
            <td>{{ test.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Create Mapping Modal -->
<ng-template #createMappingModal>
  <div class="modal-header">
    <h5 class="modal-title">Create Mapping</h5>
    <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="createMappingForm">
      <div class="mb-3">
        <label for="company" class="form-label">Company</label>
        <select class="form-control" id="company" formControlName="company">
          <option *ngFor="let company of companies" [value]="company.organisationName">{{ company.organisationName }}
          </option>
        </select>
      </div>
      <div class="mb-3">
        <label for="selectedPackages" class="form-label">Select Packages</label>
        <ng-select [items]="packages" bindLabel="packageName" bindValue="id" placeholder="Select packages"
          formControlName="selectedPackages" [multiple]="true"></ng-select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmitMapping()">Create</button>
  </div>
</ng-template>

<!-- Create Package Modal -->
<ng-template #createPackageModal>
  <div class="modal-header">
    <h5 class="modal-title">Create Package</h5>
    <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="createPackageForm">
      <div class="mb-3">
        <label for="packageName" class="form-label">Package Name</label>
        <input type="text" class="form-control" id="packageName" formControlName="packageName">
      </div>
      <div class="mb-3">
        <label for="selectedTests" class="form-label">Select Tests</label>
        <ng-select [items]="tests" bindLabel="testName" bindValue="id" placeholder="Select tests"
          formControlName="selectedTests" [multiple]="true"></ng-select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmitPackage()">Create</button>
  </div>
</ng-template>

<!-- Create Test Modal -->
<ng-template #createTestModal>
  <div class="modal-header">
    <h5 class="modal-title">Create Test</h5>
    <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="createTestForm">
      <div class="mb-3">
        <label for="testName" class="form-label">Test Name</label>
        <input type="text" class="form-control" id="testName" formControlName="testName">
      </div>
      <div class="mb-3">
        <label for="description" class="form-label">Description</label>
        <textarea class="form-control" id="description" formControlName="description" rows="3"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmitTest()">Create</button>
  </div>
</ng-template>

<!-- Success Modal Template -->
<ng-template #successTemplate>
  <div class="modal-header">
    <h5 class="modal-title">{{ headerMessage }}</h5>
    <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body">
    <p>{{ bodyMessage }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modalRef.hide()">Close</button>
  </div>
</ng-template>

<!-- Failure Modal Template -->
<ng-template #failureTemplate>
  <div class="modal-header">
    <h5 class="modal-title">{{ headerMessage }}</h5>
    <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body">
    <p>{{ bodyMessage }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modalRef.hide()">Close</button>
  </div>
</ng-template>